import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Error403Icon } from '../../../../assets/icons/error-pages/error403.svg';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';

export default function AccessDenied() {
  const { t } = useTranslation();

  return (
    <CommonErrorPage
      errorTone="forbidden"
      errorIcon={Error403Icon}
      statusCode="403"
      title={t('errorPages.accessDenied.title')}
      description={t('errorPages.accessDenied.description')}
      buttonText={t('errorPages.accessDenied.goHome')}
    />
  );
}
